module.exports = __webpack_public_path__ + "static/img/50.d1e4ac2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s31/pop/50.png
// module id = 8yeR
// module chunks = 2